import styled from 'styled-components/macro';

export const MainContainer = styled.div`
  margin: 0px 0px 0px 200px;
  padding: 20px 52px;
  min-height: 700px;
`;
